import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function getCart(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, locale, langId, profileName, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of getCart()');
    invariant(brandId, 'brandId is a required param of getCart()');
    invariant(country, 'country is a required param of getCart()');
    invariant(uberToken, 'uberToken is a required param of getCart()');
    invariant(clientId, 'clientId is a required param of getCart()');

    const query = querystring.stringify({ langId, locale, profileName });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self${query ? `?${query}` : ''}`;
    const headers = {
        ...additionalHeaders,
    };

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getCart');
}
